/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Turn on the case-insensitive toggle in alphabetical mode and uppercase and lowercase letters are treated as equal, so 'Apple' and 'apple' sort together instead of all capitals appearing first.`)
};

const es_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Activa la opción de insensibilidad a mayúsculas en modo alfabético y las letras mayúsculas y minúsculas se tratan como iguales, por lo que 'Apple' y 'apple' se ordenan juntas en lugar de que todas las mayúsculas aparezcan primero.`)
};

const de_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Aktivieren Sie im alphabetischen Modus den Schalter Groß-/Kleinschreibung ignorieren, dann werden Groß- und Kleinbuchstaben als gleich behandelt, sodass 'Apple' und 'apple' zusammen sortiert werden, anstatt dass alle Großschreibungen zuerst erscheinen.`)
};

const nl_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Schakel de niet-hoofdlettergevoelige schakelaar in alfabetische modus in en hoofd- en kleine letters worden als gelijk behandeld, dus 'Apple' en 'apple' sorteren samen in plaats van alle kapitalen eerst.`)
};

const fr_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Activez le bouton bascule insensible à la casse en mode alphabétique et les lettres majuscules et minuscules sont traitées comme égales, donc Apple et apple se trient ensemble au lieu que tous les majuscules apparaissent en premier.`)
};

const it_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Attiva l'interruttore Ignora maiuscole/minuscole in modalità alfabetica e le lettere maiuscole e minuscole vengono trattate come uguali, quindi Apple e apple vengono ordinati insieme invece che tutti i caratteri maiuscoli appaiano prima.`)
};

const pt_br2_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Ative a alternância sem distinção de maiúsculas no modo alfabético e as letras maiúsculas e minúsculas são tratadas como iguais, portanto 'Apple' e 'apple' são ordenadas juntas em vez de todas as maiúsculas aparecerem primeiro.`)
};

const pt_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Ative a alternância insensível a maiúsculas/minúsculas no modo alfabético e letras maiúsculas e minúsculas são tratadas como iguais, portanto 'Apple' e 'apple' são classificadas juntas em vez de todos os maiúsculos aparecerem primeiro.`)
};

const ja_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。アルファベット順モードで大文字小文字区別なしトグルをオンにすると、大文字と小文字が同等として扱われるため、すべての大文字が最初に表示されるのではなく、「Apple」と「apple」がまとめてソートされます。`)
};

const zh_ls_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。在字母模式下打开不区分大小写开关，大写和小写字母会被视为相同，因此“Apple”和“apple”会排在一起，而不是所有大写字母都排在最前面。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_faq4_a", locale)
	if (locale === "en") return en_ls_faq4_a(inputs)
	if (locale === "es") return es_ls_faq4_a(inputs)
	if (locale === "de") return de_ls_faq4_a(inputs)
	if (locale === "nl") return nl_ls_faq4_a(inputs)
	if (locale === "fr") return fr_ls_faq4_a(inputs)
	if (locale === "it") return it_ls_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_ls_faq4_a(inputs)
	if (locale === "pt") return pt_ls_faq4_a(inputs)
	if (locale === "ja") return ja_ls_faq4_a(inputs)
	return zh_ls_faq4_a(inputs)
};